// Normaliza tanto los estados nuevos como los valores históricos guardados.
// Así cliente, perfil y administración muestran exactamente el mismo mensaje.
export const getPaymentStatus = (value) => {
  const status = String(value || 'pending').trim().toLowerCase();

  if (['completed', 'paid', 'approved', 'success', 'succeeded'].includes(status)) return 'completed';
  if (['rejected', 'declined', 'failed', 'error'].includes(status)) return 'rejected';
  if (['cancelled', 'canceled', 'voided'].includes(status)) return 'cancelled';
  return 'pending';
};

export const getPaymentStatusMeta = (value) => {
  const status = getPaymentStatus(value);
  const metadata = {
    completed: {
      label: 'Pago confirmado',
      shortLabel: 'Pagado',
      className: 'bg-emerald-50 text-emerald-700 border-emerald-200'
    },
    pending: {
      label: 'Pago pendiente',
      shortLabel: 'Pendiente',
      className: 'bg-amber-50 text-amber-700 border-amber-200'
    },
    rejected: {
      label: 'Pago rechazado',
      shortLabel: 'Rechazado',
      className: 'bg-rose-50 text-rose-700 border-rose-200'
    },
    cancelled: {
      label: 'Pago cancelado',
      shortLabel: 'Cancelado',
      className: 'bg-slate-100 text-slate-700 border-slate-200'
    }
  };

  return { status, ...metadata[status] };
};
